<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="3">
        <h1 class="text-2xl">
          Venues
        </h1>
      </v-col>
      <v-col class="d-flex justify-center">
        <v-btn-toggle
            v-model="cityId"
            borderless
            class="q-tabs shadow-0 bordered"
            mandatory
            @change="filter"
        >
          <v-btn height="40" value="all">All</v-btn>
          <v-btn v-for="city in tabCities" :key="city.id" :value="city.id" height="40">
            {{ city.name }}
          </v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col class="d-flex align-center gap-x-4" lg="4" md="3">

        <v-select
            class="q-text-field shadow-0 bg-white w-200"
            outlined
            dense
            placeholder="Status"
            hide-details="auto"
            :menu-props="{ bottom: true, offsetY: true }"
            item-value="id"
            item-text="name"
            :items="[{id:'all',name:'All'},{id:1,name:'Active'}, {id:2,name:'Inactive'}]"
            validate-on-blur
            @change="filter"
            v-model="statusId"
        ></v-select>

        <v-text-field
            v-model="search"
            class="q-text-field shadow-0 bg-white "
            dense
            height="40"
            hide-details
            outlined
            placeholder="Search"
            @keyup="filter"

        >
          <template #prepend-inner>
            <SearchIcon/>
          </template>
        </v-text-field>
        <v-btn
            class="white--text blue-color ml-1"
            color="darken-1"
            height="40"
            @click="addVenue"
        >
          <SvgIcon text="Add Venue">
            <template #icon>
              <AddIcon/>
            </template>
          </SvgIcon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col
          v-for="(data) in filteredVenues"
          :key="data.id"
          lg="4"
          md="6"
          xl="3"
      >
        <VenueCard :venue="data" @confirm-activate="confirmActiveInactive"/>
      </v-col>
    </v-row>

    <confirm-model
        v-bind="confirmModel"
        @confirm="confirmActions"
        @close="confirmModel.id = null"
    ></confirm-model>
  </v-container>
</template>
<script>
import VenueCard from "@/components/Venues/VenueCard.vue";
import SearchIcon from "@/assets/images/misc/search.svg";
import AddIcon from "@/assets/images/misc/plus-icon.svg";
import SvgIcon from "@/components/Image/SvgIcon.vue";
import moment from "moment";

export default {
  components: {SvgIcon, SearchIcon, VenueCard, AddIcon},
  data() {
    return {
      expiry_alert_days:30,
      filteredVenues: [],
      venues: [],
      page: 1,
      totalPages: 1,
      show2: false,
      height: 500,
      selectAll: false,
      confirmModel: {
        id: null,
        title: null,
        description: null,
      },
      otp_mode: 1,
      search: "",
      statusId:'all',
      cityId: "all"
    };
  },
  mounted() {
    this.getVenues();
    this.getModules();
    if (this.$store.getters.getCountries.status == false) {
      this.$store.dispatch("loadCountries");
    }
    if (this.$store.getters.getCities.status == false) {
      this.$store.dispatch("loadCities");
    }
    if (this.$store.getters.getServices.status == false) {
      this.$store.dispatch("loadServices");
    }
    if (this.$store.getters.getServices.status == false) {
      this.$store.dispatch("loadVenues");
    }
  },
  computed: {
    countries() {
      return this.$store.getters.getCountries.data;
    },
    cities() {
      return this.$store.getters.getCities.data;
    },
    services() {
      return this.$store.getters.getServices.data;
    },
    tabCities() {
      const ids = this.venues.map(v => v.city_id);
      return this.cities.filter(c => ids.includes(c.id));
    }
  },
  watch: {
    page() {
      this.getVenues();
    },
  },
  methods: {
    filter() {
      this.filteredVenues = this.venues.filter((item) => {
        const matchesSearch = this.search ? item.name.toLowerCase().includes(this.search.toLowerCase()) : true;
        const matchesCityId = this.cityId && this.cityId !== 'all' ? item.city_id === this.cityId : true;
        const matchesStatusId = this.statusId && this.statusId !== 'all' ? item.status_id === this.statusId : true;
        return matchesSearch && matchesCityId && matchesStatusId;
      });
    },
    confirmActions(data) {
      console.log('dataaaaaa',data)
      this.toggleVenueStatus(data.id)
      this.confirmModel.id = null;
    },

    confirmActiveInactive(data) {
      this.confirmModel = {
        id: data.id,
        title: `Do you want to ${
            data.status_id == 1 ? "Deactivate" : "Reactivate"
        } this venue?`,
        description:
            "By clicking <b>Yes</b> you can confirm the operation.  Do you need to continue your action ?",
        type: "venue",
        data: {
          flag: data.flag ? true : false,
        },
      };
    },


    toggleVenueStatus(id) {
      this.$http
          .put(`venues/${id}/status`)
          .then((response) => {
            console.log(response)
            this.getVenues();
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },

    getModules() {
      this.$http
          .get("/modules")
          .then((response) => {
            if (response.status == 200) {
              const data = response.data.data;
              this.modules = data;
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },
    getVenues() {
      this.showLoader("Loading")
      let url = "venues?per_page=10&page=" + this.page;
      this.$http
          .get(url)
          .then((response) => {
            if (response.status == 200 && response.data.status) {
              this.venues = response.data.data;

              this.venues.map((ele)=> {
                if(ele.agreement_end_date && (moment(ele.agreement_end_date,'YYYY-MM-DD').diff(moment(),'days') < this.expiry_alert_days) ){
                  ele.is_expiring = 1;
                }else{
                  ele.is_expiring = 0;
                }
              })
              this.totalPages = response.data.totalPages;
              this.filteredVenues = this.venues;
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          })
          .finally(() => {
            this.hideLoader()
          });
    },
    addVenue() {
      this.$router.push({name: "CreateOrUpdateVenue"});
    },
  },
};
</script>
<style lang="scss" scoped>
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  .v-btn.v-btn {
    border-color: unset !important;

    &:not(:last-child) {
      border-right: 1px solid rgba(220, 220, 220, 1) !important;
    }
  }

}
</style>
